import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSleepGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M25.564 18.084a.75.75 0 0 0-.69-.46h-4.187c-.41 0-.75.34-.75.75s.34.749.75.749h2.378l-2.908 2.908a.75.75 0 0 0 .53 1.28h4.187c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.378l2.908-2.908c.21-.22.27-.54.16-.82ZM21.296 28.877h-2.378l2.908-2.908a.75.75 0 0 0-.53-1.28H17.11c-.41 0-.75.34-.75.75s.34.75.75.75h2.378l-2.908 2.908a.75.75 0 0 0 .53 1.28h4.187c.41-.001.75-.34.75-.75s-.34-.75-.75-.75ZM29.111 29.627c0-.41-.34-.75-.75-.75h-2.378l2.909-2.908a.75.75 0 0 0-.53-1.28h-4.188c-.41 0-.749.34-.749.75s.34.75.75.75h2.378l-2.908 2.908a.75.75 0 0 0 .53 1.28h4.187c.41-.001.75-.33.75-.75Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M38.975 27.868c-2.368-2.359-2.398-3.618-2.438-5.707-.03-1.519-.07-3.398-1.06-6.166C33.36 10.099 26.903 8 21.567 8c-4.538.01-8.406 1.789-10.894 5.017-2.618 3.398-3.338 7.965-2.049 12.852a.75.75 0 1 0 1.45-.39c-1.17-4.417-.53-8.525 1.788-11.543 2.199-2.858 5.637-4.427 9.694-4.427 4.827 0 10.643 1.839 12.502 7.006.91 2.528.94 4.207.98 5.686.05 2.209.08 3.948 2.888 6.736.35.34.48.56.54.67-.19.11-.62.22-.87.29-.75.2-1.679.449-1.799 1.309-.03.24-.01.55.02 1.009.09 1.329.25 3.817-1.04 5.197-.669.72-1.718 1.089-3.097 1.089h-1c-1.399 0-2.728.01-3.927-.06a.75.75 0 0 0-.79.71c-.02.41.29.77.71.789.97.05 1.989.06 3.058.06h1.959c1.809 0 3.218-.53 4.187-1.559 1.74-1.849 1.54-4.757 1.44-6.316-.01-.19-.03-.41-.03-.56.17-.08.499-.16.699-.22.77-.21 1.739-.46 1.969-1.329.21-.84-.46-1.629-.98-2.148Z",
    fill: "currentColor"
  }));
}

export { SvgSleepGlyphSecondary as default };
